import React, { useEffect, useState } from "react";
import apiRequest from "../../../../utils/ApiRequest/apiRequest.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import Button from "../../../Elements/Button/Button.js";
import parse from "html-react-parser";
import { useToasts } from "react-toast-notifications";
import config from "config";
import ToastHtmlComponent from "../../../Reusable/ToastHtmlComponent/ToastHtmlComponent.js";
import EmbedLimitOptionsModal from "../../../Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";
import { useModal } from "../../../../contexts/modalContext/modalContext.js";
import Icon from "../../../Elements/Icon/Icon.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";

const StatusesManagement = ({ userData, availableAllPages }) => {
  const { addToast } = useToasts();
  const { setModal, closeModal } = useModal();
  const maxLimit = 30;
  const { getTextByKey, getPageText, getLanguageCulture } = useContent();
  const [embedStatusesList, setEmbedStatusesList] = useState([]);
  const [oldEmbedStatusesList, setOldEmbedStatusesList] = useState([]);
  const [embedStatusesSystem, setEmbedStatusesSystem] = useState([]);
  const [newStatusName, setNewStatusName] = useState(null);
  const [invalidStatusName, setInvalidStatusName] = useState(false);
  const [invalidEditStatusName, setInvalidEditStatusName] = useState(false);
  const [updateStatuses, setUpdateStatuses] = useState(false);
  const [editStatus, setEditStatus] = useState("");
  const [isEditStatus, setIsEditStatus] = useState(null);
  const [editStatusDetails, setEditStatusDetails] = useState(null);
  const [focusInputNewStatus, setFocusInputNewStatus] = useState(false);
  const colorList = [
    { color: "#83D43D" },
    { color: "#F9B32F" },
    { color: "#59AF0E" },
    { color: "#9A67BD" },
    { color: "#40D6F4" },
    { color: "#C54163" },
    { color: "#DF5724" },
    { color: "#35A26A" },
  ];
  const systemNames = {
    ordercreated: "rgb(4, 82, 129)",
    uploading: "rgb(10, 130, 197)",
    pending_download: "#1BAAE1",
    downloaded: "rgb(158, 193, 38)",
    sent: "#FFCA00",
    pending_removed: "#F79100",
    removed: "#e70666",
    error: "#88148C",
    uploading_error: "a9148c",
  };
  const formStatusColorsObj = {
    ordercreated: "rgb(4, 82, 129)",
    uploading: "rgb(10, 130, 197)",
    sent: "rgb(45, 174, 184)",
    downloaded: "rgb(158, 193, 38)",
    pending_removed: "rgb(251, 174, 0)",
    removed: "rgb(244, 99, 11)",
    error: "rgb(233, 18, 86)",
    uploading_error: "rgb(189, 18, 136)",
    custom1: "#F24812",
    custom2: "#E6006D",
    custom3: "#B7148C",
    custom4: "#88148C",
    custom5: "#F79100",
  };

  //Get all User's statuses
  const getAllEmbedStatusesByUser = async () => {
    const response = await apiRequest(
      "EmbedDynamics",
      "GetEmbedStatusListByUserIdReact"
    );
    if (response.status === "success") {
      if (response.data) {
        if (response.data.EmbedStatusesList) {
          setEmbedStatusesList(response.data.EmbedStatusesList);
          setOldEmbedStatusesList(response.data.EmbedStatusesList);
        }
      }
    } else {
    }
  };

  //Get all system's statuses
  const getAllEmbedStatusesBySystem = async (culture) => {
    const parameters = {
      culture: culture,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "GetEmbedSystemStatuses",
      parameters
    );
    if (response.status === "success") {
      setEmbedStatusesSystem(response.data);
    } else {
    }
  };

  useEffect(() => {
    getAllEmbedStatusesByUser();
    getAllEmbedStatusesBySystem(getLanguageCulture());
  }, [userData.UserId, getLanguageCulture]);

  useEffect(() => {
    if (newStatusName === "") {
      setInvalidStatusName(true);
    } else {
      setInvalidStatusName(false);
    }
  }, [newStatusName]);

  //Save new status to an array
  const addStatusFunction = () => {
    if (availableAllPages) {
      if (embedStatusesList.length > 4) {
        addToast(getTextByKey("max-limit-statuses"), {
          appearance: "error",
        });
      } else {
        if (newStatusName.trim() !== "" && newStatusName.trim() !== null) {
          if (newStatusName.includes("~")) {
            addToast(getTextByKey("tilda-status-error"), {
              appearance: "error",
            });
            setInvalidStatusName(true);
          } else if (newStatusName.length > 30) {
            addToast(getTextByKey("title-status-too-long"), {
              appearance: "error",
            });
          } else {
            let inArraySystem = embedStatusesSystem.filter(
              (item) =>
                item.Status.toLowerCase() === newStatusName.toLowerCase()
            );
            let inArrayUser = embedStatusesList.filter(
              (item) =>
                item.StatusTitle.toLowerCase() === newStatusName.toLowerCase()
            );
            if (inArraySystem.length > 0 || inArrayUser.length > 0) {
              addToast(getTextByKey("same-status-error"), {
                appearance: "error",
              });
              setInvalidStatusName(true);
            } else {
              let tempNewStatus = {
                SendMailOnChange: false,
                StatusCreationDate: new Date(),
                StatusOrder: embedStatusesList.length,
                StatusTitle: newStatusName,
              };
              setEmbedStatusesList((prev) => [...prev, tempNewStatus]);
              setUpdateStatuses(true);
              setNewStatusName(null);
              setInvalidStatusName(false);
            }
          }
        } else {
          setInvalidStatusName(true);
        }
      }
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  //update Statuses list in DB
  const saveNewList = async ({ listStatuses, typeUpdate }) => {
    if (listStatuses.length > 5) {
      addToast(getTextByKey("max-limit-statuses"), {
        appearance: "error",
      });
    } else {
      let newArray = [];
      if (typeUpdate === "edit") {
        newArray = embedStatusesList;
      } else {
        for (let i = 0; i < listStatuses.length; i++) {
          const item = listStatuses[i];
          item.StatusOrder = i;
          newArray.push(item);
        }
      }

      const requestBody = {
        EmbedStatusesList: newArray,
      };
      const response = await apiRequest(
        "EmbedDynamics",
        "UpdateEmbedStatusesReact",
        requestBody,
        "POST"
      );
      if (response.status === "success") {
        if (response.data === 590) {
          addToast(getTextByKey("sql-Injection-status-error"), {
            appearance: "error",
          });
        } else if (response.data === 0) {
          if (typeUpdate === "delete") {
            addToast(getTextByKey("delete-status-success"), {
              appearance: "success",
            });
          } else if (typeUpdate === "add") {
            addToast(getTextByKey("add-status-success"), {
              appearance: "success",
            });
          } else {
            addToast(getTextByKey("edit-status-success"), {
              appearance: "success",
            });
          }

          setOldEmbedStatusesList(embedStatusesList);
        } else {
          let errText = getTextByKey("api-error");
          errText = errText.replace("#ERRORNUM#", response.data);
          errText = errText.replace("#SYSMAIL#", "contact-us");
          errText = errText.replace("#SYSMAIL#", config.supportmail);
          errText = errText.replace("#SYSMAIL#", "contact-us");
          addToast(<ToastHtmlComponent htmlStr={errText} />, {
            appearance: "error",
          });
        }
      } else {
        let errText = getTextByKey("api-error");
        errText = errText.replace("#ERRORNUM#", 765346);
        errText = errText.replace("#SYSMAIL#", "contact-us");
        errText = errText.replace("#SYSMAIL#", config.supportmail);
        errText = errText.replace("#SYSMAIL#", "contact-us");
        addToast(<ToastHtmlComponent htmlStr={errText} />, {
          appearance: "error",
        });
      }
    }
  };

  //delete Status from array
  const deleteEmbedStatus = (StatusTitle) => {
    if (availableAllPages) {
      setEmbedStatusesList((prev) =>
        prev.filter((item) => item.StatusTitle !== StatusTitle)
      );
      setUpdateStatuses(true);
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  useEffect(() => {
    if (updateStatuses) {
      let typeUpdate = "";
      if (oldEmbedStatusesList.length > embedStatusesList.length) {
        typeUpdate = "delete";
      } else if (oldEmbedStatusesList.length < embedStatusesList.length) {
        typeUpdate = "add";
      } else {
        typeUpdate = "edit";
      }
      saveNewList({ listStatuses: embedStatusesList, typeUpdate: typeUpdate });
      setUpdateStatuses(false);
    }
  }, [updateStatuses, embedStatusesList]);

  const enterButtonFunction = (e) => {
    if (e.key === "Enter") {
      addStatusFunction();
    }
  };

  const editStatusFunction = (status) => {
    setEditStatus(status.StatusTitle);
    setIsEditStatus(status.StatusId);
    setEditStatusDetails(status);
  };

  const handleChangeNewStatus = (e) => {
    if (e === "") {
      setNewStatusName(null);
    } else if (e.length <= 30) {
      setNewStatusName(e);
    }
  };

  const handleChangeEditStatus = (e) => {
    if (e.length <= 30) {
      setEditStatus(e);
    }
  };

  const saveEditStatus = () => {
    if (editStatus.trim() === "" || editStatus.trim() === null) {
      setInvalidEditStatusName(isEditStatus);
    } else if (editStatus.length > 30) {
      addToast(getTextByKey("title-status-too-long"), {
        appearance: "error",
      });
      setInvalidEditStatusName(isEditStatus);
    } else if (editStatus.includes("~")) {
      addToast(getTextByKey("tilda-status-error"), {
        appearance: "error",
      });
      setInvalidEditStatusName(isEditStatus);
    } else {
      setInvalidEditStatusName(null);
      let newStatus = { ...editStatusDetails };
      newStatus.StatusTitle = editStatus.trim();
      const newArray = embedStatusesList.map((obj) => {
        // 👇️ if id equals 2 replace object
        if (obj.StatusId === isEditStatus) {
          return newStatus;
        }
        // 👇️ otherwise return object as is
        return obj;
      });
      setEmbedStatusesList(newArray);
      setUpdateStatuses(true);
      setIsEditStatus(null);
      setInvalidEditStatusName(null);
      setEditStatus("");
    }
  };
  return (
    <div className="statuses-management-conitaner">
      <div className="statuses-management-title embed-page-title">
        <h3>{getTextByKey("profile-menu-jumboform-statuses-management")}</h3>
        {getPageText().TextBox && <p>{parse(getPageText().TextBox)}</p>}
      </div>
      <div className="statuses-list">
        <div className="system-list">
          <h4>{getTextByKey("default-statuses")}</h4>
          <ul>
            {embedStatusesSystem
              ? embedStatusesSystem.map((item, i) => (
                  <li key={i}>
                    <i
                      style={{
                        color: formStatusColorsObj[
                          item.SystemStatus.toLowerCase() === "created"
                            ? "ordercreated"
                            : item.SystemStatus.toLowerCase()
                        ]
                          ? formStatusColorsObj[
                              item.SystemStatus.toLowerCase() === "created"
                                ? "ordercreated"
                                : item.SystemStatus.toLowerCase()
                            ]
                          : "#8a2be2",
                      }}
                      className="fas fa-circle"
                    ></i>{" "}
                    {item.Status}
                    <Tooltip
                      id={`${item.SystemStatus}-${i}`}
                      tooltipText={item.StatusText}
                    >
                      <Icon
                        name="question-circle"
                        iconClass="tooltip-question"
                      />
                    </Tooltip>
                  </li>
                ))
              : null}
          </ul>
        </div>
        <div className="user-list">
          <h4>{getTextByKey("additional-statuses")}</h4>
          <div
            className={`add-new-status ${
              invalidStatusName ? "invalid-input" : ""
            }`}
          >
            <div
              className={`add-status-div-input ${
                newStatusName && newStatusName.length >= 30 ? "over" : ""
              }`}
            >
              <input
                onFocus={() => setFocusInputNewStatus(true)}
                onBlur={() => setFocusInputNewStatus(false)}
                value={!newStatusName ? "" : newStatusName}
                onChange={(e) => handleChangeNewStatus(e.target.value)}
                onKeyDown={(e) => enterButtonFunction(e)}
                placeholder={getTextByKey("status-name-placeholder")}
                type="text"
              />
              <div className={`max-chars ${focusInputNewStatus}`}>
                <span className="show-chars" style={{ direction: "ltr" }}>
                  {newStatusName ? newStatusName.length : 0} / {maxLimit}
                </span>
              </div>
            </div>

            <Button
              onClick={() => {
                addStatusFunction();
              }}
            >
              + {getTextByKey("add-new-status")}
            </Button>
          </div>
          <ul>
            {embedStatusesList
              ? embedStatusesList.map((item, i) => (
                  <li className="newStatusItem" key={i}>
                    <div className="header-new-status">
                      <div className="new-status-name">
                        <i
                          style={{
                            color: formStatusColorsObj["custom" + (i + 1)],
                          }}
                          className="fas fa-circle"
                        ></i>{" "}
                        {isEditStatus === item.StatusId ? (
                          <div
                            className={`edit-div-input ${
                              editStatus && editStatus.length >= 30
                                ? "over"
                                : ""
                            }`}
                          >
                            <input
                              type="text"
                              className={`edit-input ${
                                invalidEditStatusName === item.StatusId
                                  ? "invalid"
                                  : ""
                              }`}
                              value={editStatus}
                              onChange={(e) =>
                                handleChangeEditStatus(e.target.value)
                              }
                            />
                            <div className="max-chars">
                              <span
                                className="show-chars"
                                style={{ direction: "ltr" }}
                              >
                                {editStatus ? editStatus.length : 0} /{" "}
                                {maxLimit}
                              </span>
                            </div>
                          </div>
                        ) : (
                          <span>{item.StatusTitle}</span>
                        )}
                      </div>
                      <div
                        className={`actions ${
                          isEditStatus === item.StatusId ? "is-edit-status" : ""
                        }`}
                      >
                        {isEditStatus === item.StatusId ? (
                          <div
                            className="edit-status-action"
                            onClick={() => saveEditStatus()}
                          >
                            <span className="v-icon">
                              <i class="fa fa-check" aria-hidden="true"></i>
                            </span>
                          </div>
                        ) : (
                          <span
                            className="action"
                            onClick={() => editStatusFunction(item)}
                          >
                            <Icon name="pencil-alt-solid" />
                          </span>
                        )}

                        <span className="action">
                          <i
                            onClick={() => {
                              deleteEmbedStatus(item.StatusTitle);
                            }}
                            className="fas fa-trash"
                          ></i>
                        </span>
                      </div>
                    </div>
                  </li>
                ))
              : null}
          </ul>
          {/* <div className="save-status">
            <Button
              onClick={() => {
                saveNewList();
              }}
            >
              {getTextByKey("save-statuses")}
            </Button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default StatusesManagement;
